export interface ColorGroup {
    light: string;
    main: string;
    dark: string;
}

export interface Color {
    black: string;
    white: string;
    background: string;
    text: string;
    primary: ColorGroup;
    secondary: ColorGroup;
    accent: ColorGroup;
    success: string;
    error: string;
}

// TODO: I'm guessing on most of the colors for now.
export function createColor(props: Partial<Color> = {}): Color {
    return {
        black: '#000',
        white: '#fff',
        background: '#2a2a2a',
        text: '#eee',
        accent: {
            light: '#33abff',
            main: '#0078f2',
            dark: '#0045bf'
        },
        primary: {
            light: '#2b2b2b',
            main: '#202020',
            dark: '#121212'
        },
        secondary: {
            light: '#f00',
            main: '#f00',
            dark: '#f00'
        },
        success: '#95c990',
        error: '#dc5353',
        ...props
    };
}
